const actual = 'actual';
const budget = 'budget';
const constraint = 'constraint';
const plan = 'plan';


export const PlanTypes = Object.freeze({
    [actual]: 0,
    [budget]: 1,
    [constraint]: 2,
    [plan]: 3,
});

export const PlanTypesKeys = Object.freeze({
    0: actual,
    1: budget,
    2: constraint,
    3: plan,
});
